import { usePostHog } from 'posthog-js/react';
import React from 'react';

import { Button, Stack } from 'gooey';
import { GlowCard } from '#/components/design';
import { useWindowLoad } from '#/hooks/use-window-load';
import { ClientOnly } from '#/lib/client-only';
import { usePrivacy } from './use-privacy';

export function PrivacyConfirm() {
  const [render, setRender] = React.useState(false);
  const [confirmed, setConfirm] = usePrivacy();
  const posthog = usePostHog();

  useWindowLoad(() => {
    setTimeout(() => {
      setRender(true);
    }, 500);
  });

  function handleConfirm(confirm: boolean) {
    if (confirm) {
      posthog?.opt_in_capturing();
    } else {
      posthog?.opt_out_capturing();
    }
    setConfirm(confirm);
  }

  if (confirmed !== null || !posthog || !render) {
    return null;
  }

  return (
    <ClientOnly>
      {() => (
        <div className='fixed bottom-4 left-4 max-w-[364px] z-[99999999999999999999]'>
          <GlowCard gutter='none' className='px-2 py-4'>
            <Stack
              direction='column'
              spacing={2}
              alignItems='center'
              className='text-center text-gray-300'
            >
              <Stack>
                <div className='text-md font-bold'>Life is better with cookies 🍪</div>
                <div className='mx-auto text-sm'>
                  We appreciate cookies, as they help the Joggr Team make our site better. We'll
                  assume you're ok with this, but you can opt out if you wish.
                </div>
              </Stack>
              <Stack
                direction='row'
                spacing={1}
                justifyContent='center'
                alignItems='center'
                className='mx-auto'
              >
                <Button variant='contained' size='small' onClick={() => handleConfirm(true)}>
                  Accept All
                </Button>
                <Button variant='outlined' size='small' onClick={() => handleConfirm(false)}>
                  Disable All
                </Button>
              </Stack>
            </Stack>
          </GlowCard>
        </div>
      )}
    </ClientOnly>
  );
}
